<div *ngIf="filterVisibilitySettings.isShowFilterHeader">
    <span><i class="mr-3 fa fa-filter fa-lg"></i><b>Filter Options</b></span>
    <span *ngIf="!isCustomer" class="float-right text-danger btn" (click)="toggleMoreFilter()">
        <b>More Filters <i id="moreFilterIcon" class="fa fa-chevron-down ml-3"></i></b>
    </span>
    <ng-container>
        <span id="saveFilter" name="saveFilter" class="mr-2 float-right cursorPointer saveFilterOption px-2 py-1"
            title="Manage member preference settings" data-toggle="modal" data-target="#userPreferenceSetting"
            (click)="isShowMemberPreferenceSettingPopup=!isShowMemberPreferenceSettingPopup">
            <i class="fa fa-cog fa-lg" aria-hidden="true"></i>
        </span>
    </ng-container>
</div>
<hr class="hr-class my-4" *ngIf="filterVisibilitySettings.isShowFilterHeader">
<div class="row">
    <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="filterVisibilitySettings.serviceTypeDropdown">
        <div class="filter-option-div mb-3">
            <label *ngIf="filterVisibilitySettings.isShowLable">Service Type</label>
            <div class="select-box">
                <ng-multiselect-dropdown-angular7 [placeholder]="'Service Type'"
                    (ngModelChange)="applyFilterIfAplicable()" [settings]="dropDownSettings.ServiceDropdownSettings"
                    [data]="filterDropdownData.serviceTypeList"
                    [(ngModel)]="filterDropdownData.selectedServiceTypeList">
                </ng-multiselect-dropdown-angular7>
            </div>
        </div>
    </div>
    <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="filterVisibilitySettings.legStatusDropdown">
        <div class="filter-option-div mb-3">
            <!-- This dropdown is for leg Status -->
            <label *ngIf="filterVisibilitySettings.isShowLable">Status</label>
            <div class="select-box">
                <ng-multiselect-dropdown-angular7 [placeholder]="'Status'" (ngModelChange)="applyFilterIfAplicable()"
                    [settings]="dropDownSettings.StatusDropdownSettings" [data]="filterDropdownData.legStatusList"
                    [(ngModel)]="filterDropdownData.selectedLegStatusList">
                </ng-multiselect-dropdown-angular7>
            </div>
        </div>
    </div>
    <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="filterVisibilitySettings.srStatusDropDown">
        <div class="filter-option-div mb-3">
            <!-- This dropdown is for Service Request Status -->
            <label *ngIf="filterVisibilitySettings.isShowLable">Status</label>
            <div class="select-box">
                <ng-multiselect-dropdown-angular7 [placeholder]="'Status'" (ngModelChange)="applyFilterIfAplicable()"
                    [settings]="dropDownSettings.StatusDropdownSettings" [data]="filterDropdownData.srStatusList"
                    [(ngModel)]="filterDropdownData.selectedSrStatusList">
                </ng-multiselect-dropdown-angular7>
            </div>
        </div>
    </div>
    <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="filterVisibilitySettings.unosDropdown">
        <div class="filter-option-div mb-3">
            <label *ngIf="filterVisibilitySettings.isShowLable">UNOS ID</label>
            <div class="select-box">
                <ng-multiselect-dropdown-angular7 id="unosIdListDropdown" [placeholder]="'UNOS ID'"
                    (ngModelChange)="applyFilterIfAplicable()" [settings]="dropDownSettings.CommonDropdownSettings"
                    [data]="filterDropdownData.unosList" [(ngModel)]="filterDropdownData.selectedUnosList">
                </ng-multiselect-dropdown-angular7>
            </div>
        </div>
    </div>
    <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="filterVisibilitySettings.tripIdDropdown">
        <div class="filter-option-div mb-3">
            <label *ngIf="filterVisibilitySettings.isShowLable">Trip ID</label>
            <div class="select-box">
                <ng-multiselect-dropdown-angular7 id="tripIdListDropdown" [placeholder]="'TripID'"
                    (ngModelChange)="applyFilterIfAplicable()" [settings]="dropDownSettings.CommonDropdownSettings"
                    [data]="filterDropdownData.tripIdList" [(ngModel)]="filterDropdownData.selectedTripIdList">
                </ng-multiselect-dropdown-angular7>
            </div>
        </div>
    </div>
    <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="filterVisibilitySettings.tissueIdDropdown">
        <div class="filter-option-div mb-3">
            <div>
                <label>Tissue ID</label>
                <div class="select-box">
                    <ng-multiselect-dropdown-angular7 (ngModelChange)="applyFilterIfAplicable()"
                        [placeholder]="'TissueID'" [settings]="dropDownSettings.TissueIdDropdown"
                        [data]="filterDropdownData.tissueIdList" [(ngModel)]="filterDropdownData.selectedTissueIdList">
                    </ng-multiselect-dropdown-angular7>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="filterVisibilitySettings.customerDropdown">
        <div class="filter-option-div mb-3">
            <label *ngIf="filterVisibilitySettings.isShowLable">Customer
            </label>
            <div class="select-box">
                <ng-multiselect-dropdown-angular7 [placeholder]="'Customer'" (ngModelChange)="applyFilterIfAplicable()"
                    [settings]="dropDownSettings.CustomerDropdownSettings" [data]="filterDropdownData.customerList"
                    [(ngModel)]="filterDropdownData.selectedCustomerList">
                </ng-multiselect-dropdown-angular7>
            </div>
        </div>
    </div>
    <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="filterVisibilitySettings.originLocationDropdown">
        <div class="filter-option-div mb-3">
            <label *ngIf="filterVisibilitySettings.isShowLable">Origin</label>
            <div class="select-box">
                <ng-multiselect-dropdown-angular7
                  placeholder="Origin"
                  (ngModelChange)="applyFilterIfAplicable()"
                  [settings]="dropDownSettings.LocationDropdownSettings"
                  [data]="filterDropdownData.originLocationList"
                  [(ngModel)]="filterDropdownData.selectedOriginLocationList">
                </ng-multiselect-dropdown-angular7>
            </div>
        </div>
    </div>
    <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="filterVisibilitySettings.destinationLocationDropdown">
        <div class="filter-option-div mb-3">
            <label *ngIf="filterVisibilitySettings.isShowLable">Destination</label>
            <div class="select-box">
                <ng-multiselect-dropdown-angular7
                  placeholder="Destination"
                  (ngModelChange)="applyFilterIfAplicable()"
                  [settings]="dropDownSettings.LocationDropdownSettings"
                  [data]="filterDropdownData.destinationLocationList"
                  [(ngModel)]="filterDropdownData.selectedDestinationLocationList">
                </ng-multiselect-dropdown-angular7>
            </div>
        </div>
    </div>
    <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="filterVisibilitySettings.fromDate">
        <div class="cursorPointer filter-option-div mb-3">
            <label *ngIf="filterVisibilitySettings.isShowLable">From Date</label>
            <button type="button" id="fromDateClear" name="clearFromDate" class="plus-icon mt-0"
                (click)="clearDate('from')" title="Clear From Date">
                <i class="fa fa-times-circle"></i>
            </button>
            <div id="fromdate" class="fromDate cursorPointer" (click)="openDatePicker('fromDate')">
                <input type="text" id="from" name="fromdate" #fromDate="ngModel" class="form-control fromDate"
                    (ngModelChange)="applyFilterIfAplicable()" [(ngModel)]="filterDropdownData.fromDate"
                    autocomplete="off" />
                <i class="fa fa-calendar calendar-icon"></i>
            </div>
        </div>
    </div>
    <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="filterVisibilitySettings.toDate">
        <div class="cursorPointer filter-option-div mb-3">

            <label *ngIf="filterVisibilitySettings.isShowLable">To Date</label>
            <button type="button" id="toDateClear" name="clearToDate" class="plus-icon mt-0" (click)="clearDate('to')"
                title="Clear To Date">
                <i class="fa fa-times-circle"></i>
            </button>
            <div id="todate" class="toDate cursorPointer" (click)="openDatePicker('toDate')">
                <input type="text" id="to" name="todate" #toDate="ngModel" class="form-control toDate"
                    (ngModelChange)="applyFilterIfAplicable()" [(ngModel)]="filterDropdownData.toDate"
                    autocomplete="off" />
                <i class="fa fa-calendar calendar-icon"></i>
            </div>

        </div>
    </div>
    <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" *ngIf="filterVisibilitySettings.isActionButtonVisible">
        <div class="cursorPointer filter-option-div mb-3">
            <label *ngIf="filterVisibilitySettings.isShowLable" class="mb-2 pb-1 visibility-hidden">Dummy
                Label</label>
            <div class="select-box">
                <button type="button" class="flat-butt flat-info-butt flat-info-grad-butt save-btn px-4"
                    (click)="applyFilter()">Apply</button>
                <button type="button" class="flat-butt flat-info-butt flat-info-grad-butt flat-danger-butt ml-4 px-3"
                    (click)="clearFilter()">Clear</button>
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="isShowMemberPreferenceSettingPopup">
    <app-member-preference-model (closeMemberPreferenceSettingPopup)="closeMemberPreferenceSettingPopup()"
        [serviceTypes]="filterDropdownData.serviceTypeList"
        [dropdownSettings]="dropDownSettings.ServiceDropdownSettings" [statusList]="filterDropdownData.srStatusList"
        [statusDropdownSettings]="dropDownSettings.StatusDropdownSettings"
        [customerList]="filterDropdownData.customerList"
        [customerListSetting]="dropDownSettings.CustomerDropdownSettings" [regionList]="regionList"
        [regionDropdownSettings]="dropDownSettings.RegionDropdownSettings"
        [financialStatusSetting]="dropDownSettings.FinancialStatusSettings"
        [serviceOriginLocations]="filterDropdownData.originLocationList"
        [originSetting]="dropDownSettings.LocationDropdownSettings" [dateFilters]="dateFilters"
        [memberPreferenceSettings]="memberPreferenceSetting" [timeZoneList]="filterDropdownData.timeZoneList"
        [timezoneConfig]="dropDownSettings.TimeZoneConfig"
        (saveMemberPreferenceSettings)="saveMemberPreferenceSettings($event);">
    </app-member-preference-model>
</ng-container>
